/* eslint-disable no-unused-vars */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import L from "leaflet";
import moment from "moment";
import { Image } from "react-bootstrap";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  Polyline,
} from "react-leaflet";
import { useCustomDispatch } from "../Global/GlobalConst";
import logo from "../../../assets/images/logo.png";
import trackingNotFound from "../../../assets/images/track-not-found.png";
import sourceIcon from "../../../assets/images/source_icon.svg";
import infoIcon from "../../../assets/images/material-symbols_info.png";
import shareLocationIcon from "../../../assets/images/bxs_share.png";
import corssIcon from "../../../assets/images/cross-icon-custom.png";
import mapReCenterBtn from "../../../assets/images/gps-icon.svg";
import hamburgericon from "../../../assets/images/hamburger-icon.png";
import OtherInfoModal from "./OtherInfoModal";
import ShareTrakingModal from "./ShareTrakingModal";
import TrackingActivityModal from "./TrackingActivityModal";
import markerICon from "../../../assets/Default/Car.svg";
import authservice from "../../../services/auth.service";
import stopUrl from "../../../assets/Stopage/Stop.svg";
import { LeafletTrackingMarker } from "react-leaflet-tracking-marker";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import { useParams } from "react-router-dom";
import Loader from "../Global/Loader";
import {
  CButton,
  CCard,
  CCardBody,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableRow,
} from "@coreui/react";
import MyMap from "../Global/myMap";

const OSMIcon = L.icon({
  iconUrl: markerICon,
  iconSize: [64, 64],
  iconAnchor: [32, 64],
  popupAnchor: [1, -68],
  labelAnchor: [14, 0],
});

const OSMIcon_1 = L.icon({
  iconUrl: stopUrl,
  iconSize: [42, 42],
  iconAnchor: [21, 42],
  popupAnchor: [-1, -48],
});

const OSMIcon_2 = L.icon({
  iconUrl: sourceIcon,
  iconSize: [40, 40],
  iconAnchor: [21, 42],
  popupAnchor: [-1, -48],
});

const UrlTracking = () => {
  const { token } = useParams();
  let minvoltage;
  let maxvoltage;
  let minpercent;
  let maxpercent;
  const animationRef = useRef(null);
  const lastLiveDistanceRef = useRef(0);
  const [apiMsg, setApiMsg] = useState();
  const [address, setAddress] = useState();
  const [ticketAddress, setTicketAddress] = useState();
  const [livePath, setLivePath] = useState([]);
  const [stopages, setStopPages] = useState([]);
  const [routePath, setRoutePath] = useState([]);
  const [map, setMap] = useState(null);
  const [prevPos, setPrevPos] = useState(null);
  const [position, setPosition] = useState(null);
  const [erssDetails, setErssDetails] = useState(null);
  const [sosAlertDetails, setSosAlertDetails] = useState(null);
  const [vehicleTrackingData, setVehicleTrackingData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [code1005, setCode1005] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [showStopage, setShowStopage] = useState(false);
  const [showRetryBtn, setShowRetryBtn] = useState(false);
  const [showOtherInfo, setShowOtherInfo] = useState(false);
  const [seeMoreDetail, setSeeMoreDetail] = useState(false);
  const [isTicketClosed, setIsTicketClosed] = useState(false);
  const [isActivityOpen, setIsActivityOpen] = useState(false);
  const [openShareTrakingModal, setOpenShareTrakingModal] = useState(false);
  const [refreshTime, setRefreshTime] = useState(10);
  const [addressIndex, setAddressIndex] = useState(-1);
  const [liveDistance, setLiveDistance] = useState(0);
  const [routeDistance, setRouteDistance] = useState(0);
  const zoomlevel = 20 || parseInt(process.env.REACT_APP_MAP_MAX_ZOOM_LEVEL);
  const [shareLocation, setShareLocation] = useState({
    latitude: "",
    longitude: "",
  });

  const startPoint = useMemo(() => {
    if (!routePath?.length) return null;

    return {
      lat: routePath[0][0],
      lng: routePath[0][1],
    };
  }, [routePath]);

  const totalDistance = useMemo(() => {
    return Number(routeDistance || 0) + Number(liveDistance || 0);
  }, [routeDistance, liveDistance]);

  const handleRecenterMap = () => {
    if (!map || !position) return;

    map.flyTo(position, map.getZoom(), {
      animate: true,
      duration: 1.2,
    });
  };

  const handleShareBtn = (e, value, status) => {
    e.stopPropagation();

    if (status === "currentLocation") {
      setShareLocation((old) => {
        return {
          ...old,
          latitude: value.latitude,
          longitude: value.longitude,
        };
      });
    }

    if (status === "stopageLocation") {
      setShareLocation((old) => {
        return {
          ...old,
          latitude: value.lat,
          longitude: value.lng,
        };
      });
    }

    setOpenShareTrakingModal(true);
  };

  const GetAddressClick = async (
    deviceLat,
    deviceLng,
    ticketLat,
    ticketLng,
  ) => {
    let deviceAddress = "";
    let ticketAddress = "";

    if (deviceLat && deviceLng) {
      await authservice
        .getAddressFromGeoAPI(deviceLat, deviceLng)
        .then((response) => {
          deviceAddress = response;
        });
      setAddress(deviceAddress);
    }
    if (ticketLat && ticketLng) {
      await authservice
        .getAddressFromGeoAPI(ticketLat, ticketLng)
        .then((response) => {
          ticketAddress = response;
        });
      setTicketAddress(ticketAddress);
    }
  };

  const GetStopageAddress = async (lat, lng, index) => {
    let url =
      "https://geoapi.umis.in/api.php?lat=" +
      lat +
      "&lng=" +
      lng +
      "&key=AIzaSyAUGv1R67G4WRhcdzFMauS3p3r_3qspj4";
    let address = "";
    await authservice.getThirdPartApi(url).then((response) => {
      if (response.response_code == "1001") {
        address = response.address;
      }
    });
    setAddressIndex(index);
    setAddress(address);
  };

  const animatePath = useCallback(
    (lastPoint, newPosition) => {
      if (animationRef.current) {
        clearInterval(animationRef.current);
      }
      const steps = 20;
      const latDiff = (newPosition[0] - lastPoint[0]) / steps;
      const lngDiff = (newPosition[1] - lastPoint[1]) / steps;
      let step = 0;
      animationRef.current = setInterval(
        () => {
          step++;

          const newPoint = [
            lastPoint[0] + latDiff * step,
            lastPoint[1] + lngDiff * step,
          ];

          setLivePath((current) => [
            ...current,
            [lastPoint[0] + latDiff * step, lastPoint[1] + lngDiff * step],
          ]);
          if (step >= steps) {
            clearInterval(animationRef.current);
          }
        },
        (refreshTime * 1000) / steps,
      );
    },
    [refreshTime],
  );

  const getTrackingData = useCallback(async () => {
    const json = { token };

    setLoading(true);

    try {
      const response = await authservice.postJsonData(
        "getVehicleTracking",
        json,
      );

      if (response?.apiResponseCode === "1001") {
        const data = response?.currentLogDetails?.[0];
        const erssDetail = response?.erssDetails;
        const newPosition = [data?.latitude, data?.longitude];

        setRefreshTime(
          response?.refreshTime?.Valid ? response?.refreshTime?.Int64 : 10,
        );

        if (erssDetail?.erssStatus === "CLOSED") {
          setIsTicketClosed(true);
        }

        // Address update check
        if (
          !position ||
          position[0] !== newPosition[0] ||
          position[1] !== newPosition[1]
        ) {
          GetAddressClick(
            data?.latitude,
            data?.longitude,
            erssDetail?.latitude,
            erssDetail?.longitude,
          );
        }

        // Update marker animation
        if (!position) {
          setPosition(newPosition);
          setPrevPos(newPosition);
        } else {
          setPrevPos(position);
          setPosition(newPosition);
        }

        // Update polyline (NO animation)
        setLivePath((prevPath) => {
          const lastPoint = prevPath[prevPath.length - 1];
          if (!lastPoint) return [newPosition];
          if (
            lastPoint[0] === newPosition[0] &&
            lastPoint[1] === newPosition[1]
          ) {
            return prevPath;
          }
          animatePath(lastPoint, newPosition);
          return prevPath;
        });

        setVehicleTrackingData(data);
        setErssDetails(erssDetail);
        setSosAlertDetails(response?.sosAlertDetails);

        const currentDistance = Number(data?.distance || 0);
        const diff = currentDistance - lastLiveDistanceRef.current;

        if (diff > 0) {
          setLiveDistance((prev) => prev + diff);
        }

        lastLiveDistanceRef.current = currentDistance;
      } else if (response?.apiResponseCode === "1003") {
        setIsExpired(true);
        setApiMsg(response?.apiResponseMsg);
      } else if (response?.apiResponseCode === "1005") {
        setApiMsg(response?.apiResponseMsg);
        setCode1005(true);
        setShowRetryBtn(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [token, position, animatePath]);

  const getRouteDataDayWise = async () => {
    if (
      !vehicleTrackingData?.ticketDateTime ||
      !erssDetails?.deviceTime ||
      !erssDetails?.closedAt
    )
      return;

    const startMoment = moment(erssDetails?.deviceTime);
    const endMoment = moment(erssDetails?.closedAt);

    if (!startMoment?.isValid() || !endMoment?.isValid()) return;

    let currentDay = startMoment?.clone()?.startOf("day");
    const lastDay = endMoment?.clone()?.startOf("day");

    let allRoutePoints = [];
    let allStopages = [];
    let totalPlaybackDistance = 0;

    while (currentDay?.isSameOrBefore(lastDay)) {
      let fromDateTime;
      let toDateTime;

      // First day
      if (currentDay?.isSame(startMoment, "day")) {
        fromDateTime = startMoment?.clone();
      } else {
        fromDateTime = currentDay?.clone()?.startOf("day");
      }

      // Last day
      if (currentDay?.isSame(endMoment, "day")) {
        toDateTime = endMoment?.clone();
      } else {
        toDateTime = currentDay?.clone()?.endOf("day");
      }

      const json = {
        imei: vehicleTrackingData?.imei,
        stateID: parseInt(process.env.REACT_APP_STATE_ID),
        fromDate: fromDateTime?.format("YYYYMMDD"),
        fromTime: fromDateTime?.format("YYYY-MM-DD HH:mm"),
        toDate: toDateTime?.format("YYYYMMDD"),
        toTime: toDateTime?.format("YYYY-MM-DD HH:mm"),
      };

      try {
        const response = await authservice.postJsonData(
          "getRoutePlayBackDetails",
          json,
        );

        if (response.apiResponseCode === "1001") {
          const totalDistance = response.deviceLogDetails?.flatMap(
            (d) => d.totalDistance,
          );
          totalPlaybackDistance += Number(totalDistance || 0);

          const points = response.deviceLogDetails
            ?.flatMap((d) => d.logsByDay)
            ?.filter((p) => p.latitude && p.longitude)
            ?.sort(
              (a, b) =>
                moment(a.deviceTime).valueOf() - moment(b.deviceTime).valueOf(),
            );

          points?.forEach((p) => {
            allRoutePoints?.push([p.latitude, p.longitude]);

            if (p.stopage === 1) {
              allStopages?.push({
                deviceTime: p.deviceTime,
                duration: p.duration?.String,
                lat: p.latitude,
                lng: p.longitude,
              });
            }
          });
        }
      } catch (err) {
        console.error(err);
      }

      currentDay?.add(1, "day");
    }

    if (allRoutePoints?.length > 0) {
      setRoutePath(allRoutePoints);
      setStopPages(allStopages);
    }

    setRouteDistance(totalPlaybackDistance);
  };

  const handleRetry = async () => {
    setShowRetryBtn(false);
    setIsExpired(false);
    setApiMsg("");
    await getTrackingData();
  };

  const batteryLevel = (batteryvol) => {
    if (batteryvol >= 3 && batteryvol <= 3.5) {
      minvoltage = 3;
      maxvoltage = 3.5;
      minpercent = 20;
      maxpercent = 50;
    } else if (batteryvol > 3.5 && batteryvol <= 3.75) {
      minvoltage = 3.5;
      maxvoltage = 3.75;
      minpercent = 50;
      maxpercent = 75;
    } else if (batteryvol > 3.75 && batteryvol <= 4) {
      minvoltage = 3.75;
      maxvoltage = 4;
      minpercent = 75;
      maxpercent = 100;
    } else if (batteryvol >= 0 && batteryvol < 3) {
      minvoltage = 0;
      maxvoltage = 3;
      minpercent = 0;
      maxpercent = 20;
    } else {
      exactVoltage = 100;
      return exactVoltage;
    }
    var n = batteryvol;
    var diff1 = n - minvoltage;
    var voltageDiff = (maxvoltage - minvoltage) * 100;
    var percentdiff = maxpercent - minpercent;
    var perecentilePoint = voltageDiff / percentdiff / 100;
    var point = diff1 / perecentilePoint;
    var exactVoltage = minpercent + point;
    return Math.round(exactVoltage);
  };

  useEffect(() => {
    if (isTicketClosed || isExpired || code1005) return;

    let isMounted = true;

    const fetchData = async () => {
      if (!isMounted) return;
      await getTrackingData();
    };

    fetchData();

    const interval = setInterval(fetchData, refreshTime * 1000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [refreshTime, isTicketClosed, isExpired, code1005]);

  useEffect(() => {
    if (!vehicleTrackingData) return;

    if (isTicketClosed || vehicleTrackingData?.ticketDateTime) {
      getRouteDataDayWise();
    }
  }, [vehicleTrackingData?.vehicleID, isTicketClosed]);

  useEffect(() => {
    if (!map) return;

    if (showStopage && routePath?.length > 1) {
      const bounds = L.latLngBounds(routePath);
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [showStopage, map, routePath]);

  useEffect(() => {
    return () => {
      if (animationRef.current) {
        clearInterval(animationRef.current);
      }
    };
  }, []);

  return (
    <div className="container">
      {isActivityOpen && (
        <TrackingActivityModal
          isActivityOpen={isActivityOpen}
          setIsActivityOpen={setIsActivityOpen}
          erssDetails={erssDetails}
        />
      )}
      {showOtherInfo && (
        <OtherInfoModal
          showOtherInfo={showOtherInfo}
          setShowOtherInfo={setShowOtherInfo}
          vehicleTrackingData={vehicleTrackingData}
        />
      )}
      {openShareTrakingModal && (
        <ShareTrakingModal
          openShareTrakingModal={openShareTrakingModal}
          setOpenShareTrakingModal={setOpenShareTrakingModal}
          shareLocation={shareLocation}
        />
      )}

      <div className="urlTracking-logo-div mt-5 mb-5">
        <Image src={logo} alt="logo" />
      </div>

      {!position && loading ? (
        <Loader />
      ) : isExpired || showRetryBtn ? (
        <div className="no-tracking-container">
          <Image
            className="track-not-found"
            src={trackingNotFound}
            alt="track-not-found"
          />
          <p
            style={{
              fontWeight: "500",
              marginTop: "0.5rem",
              fontSize: "17px",
              color: "#373636",
              textAlign: "center",
            }}
          >
            {apiMsg}
          </p>
          {showRetryBtn && (
            <button
              className="mt-2 urlTracking-retry-btn"
              onClick={handleRetry}
            >
              Retry
            </button>
          )}
        </div>
      ) : (
        <>
          <div className="urlTracking-map-wrapper-div">
            <div className="urlTracking-hederData-div">
              <div className="urlTracking-hederData-subdiv1">
                Live Tracking{" "}
                <i className="fa fa-angle-double-right" aria-hidden="true"></i>{" "}
                <span>{vehicleTrackingData?.vehicleNo}</span>
              </div>

              <div className="urlTracking-hederData-subdiv2">
                <div className="urlTracking-dropBtn-wrapper">
                  <button className="p-0" onClick={() => setIsOpen(!isOpen)}>
                    <Image
                      src={hamburgericon}
                      alt="hamburger-icon"
                      height={60}
                      width={60}
                    />
                  </button>
                </div>

                <div className={`urlTracking-dropBtn ${isOpen ? "open" : ""}`}>
                  <div className="urlTracking-dropBtn-data-container">
                    <div className="container-one">
                      <p>Vehicle Details</p>
                      <div className="sub-container">
                        <button
                          onClick={(e) =>
                            handleShareBtn(
                              e,
                              vehicleTrackingData,
                              "currentLocation",
                            )
                          }
                        >
                          <Image
                            src={shareLocationIcon}
                            alt="bxs-share-icon"
                            height={18}
                            width={18}
                          />
                        </button>
                        <button onClick={() => setShowOtherInfo(true)}>
                          <Image
                            src={infoIcon}
                            alt="material-symbols-info-icon"
                            height={18}
                            width={18}
                          />
                        </button>
                        <button onClick={() => setIsOpen(false)}>
                          <Image
                            src={corssIcon}
                            alt="material-symbols-info-icon"
                            height={20}
                            width={20}
                          />
                        </button>
                      </div>
                    </div>
                    <div className="container-two">
                      <div className="sub-container-two">
                        <h6>Vehicle Type:</h6>
                        <p>{vehicleTrackingData?.vehicleType || "-"}</p>
                      </div>
                      <div className="sub-container-two">
                        <h6>Speed (Km/h):</h6>
                        <p>{vehicleTrackingData?.speedKPH || "0"}</p>
                      </div>
                      <div className="sub-container-two">
                        <h6>Last Updated At:</h6>
                        <p>
                          {moment(vehicleTrackingData?.deviceTime).format(
                            process.env.REACT_APP_FORMATE_DATE_TIME_WITH_SECOND,
                          ) || "-"}
                        </p>
                      </div>
                      <div className="sub-container-two">
                        <h6>Address:</h6>
                        <p>{address || "-"}</p>
                      </div>
                      <div className="sub-container-two">
                        <h6>Total Distance (Km):</h6>
                        <p>{totalDistance.toFixed(2) || "0"}</p>
                      </div>

                      <div className="more-detail-btn-div">
                        <button
                          onClick={() => setSeeMoreDetail(!seeMoreDetail)}
                          className={seeMoreDetail ? "btn-is-active" : ""}
                        >
                          Other Info
                        </button>
                      </div>

                      <div
                        className={`more-detail-btn-dropDown ${
                          seeMoreDetail ? "open" : ""
                        }`}
                      >
                        <div
                          className="sub-container-two"
                          style={{ borderTop: "1px solid #dedede" }}
                        >
                          <h6>Power:</h6>
                          <p>
                            {vehicleTrackingData?.powerStatus == 1
                              ? "ON"
                              : "OFF"}
                          </p>
                        </div>
                        <div className="sub-container-two">
                          <h6>Ignition:</h6>
                          <p>
                            {" "}
                            {vehicleTrackingData?.ignition == 1 ? "ON" : "OFF"}
                          </p>
                        </div>
                        <div className="sub-container-two">
                          <h6>AC:</h6>
                          <p>{vehicleTrackingData?.ac == 1 ? "ON" : "OFF"}</p>
                        </div>
                        <div className="sub-container-two">
                          <h6>External Voltage:</h6>
                          <p>{vehicleTrackingData?.externalBattery}V</p>
                        </div>
                        <div className="sub-container-two">
                          <h6>Battery:</h6>
                          <p
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              textAlign: "start",
                              justifyContent: "end",
                            }}
                          >
                            {batteryLevel(vehicleTrackingData?.batteryLevel)}%
                            <div className="v--batery">
                              <span
                                className="bt--value"
                                style={{
                                  width:
                                    batteryLevel(
                                      vehicleTrackingData?.batteryLevel,
                                    ) + "%",
                                }}
                              ></span>
                            </div>
                          </p>
                        </div>
                        <div className="sub-container-two">
                          <h6>Emergency Alert:</h6>
                          <p> {vehicleTrackingData?.sos == 1 ? "ON" : "OFF"}</p>
                        </div>
                        <div
                          className="sub-container-two"
                          style={{
                            marginBottom: "3px",
                            borderBottom: "none",
                          }}
                        >
                          <h6>Temperature Alert:</h6>
                          <p>
                            {" "}
                            {vehicleTrackingData?.deviceTemper == "O"
                              ? "ON"
                              : "OFF"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {erssDetails !== null && (
                    <div className="urlTracking-dropBtn-data-container">
                      <div className="container-one">
                        <p>Ticket Detail</p>
                      </div>
                      <div className="container-two">
                        <div className="sub-container-two">
                          <h6>Ticket No:</h6>
                          <p>{erssDetails?.ticketNumber || "-"}</p>
                        </div>
                        <div className="sub-container-two">
                          <h6>Ticket Started At:</h6>
                          <p>
                            {moment(erssDetails?.deviceTime).format(
                              process.env
                                .REACT_APP_FORMATE_DATE_TIME_WITH_SECOND,
                            ) || "-"}
                          </p>
                        </div>
                        <div className="sub-container-two">
                          <h6>Ticket Address:</h6>
                          <p>{ticketAddress || "-"}</p>
                        </div>
                        <div className="sub-container-two">
                          <h6>Ticket End At:</h6>

                          <p>
                            {erssDetails?.erssStatus === "CLOSED"
                              ? moment(erssDetails?.closedAt).format(
                                  process.env
                                    .REACT_APP_FORMATE_DATE_TIME_WITH_SECOND,
                                )
                              : "-"}
                          </p>
                        </div>
                        <div className="sub-container-two">
                          <h6>Erss Singal ID:</h6>
                          <p>{erssDetails?.erssSignalID || "-"}</p>
                        </div>
                        <div className="sub-container-two">
                          <h6>Erss Status:</h6>
                          <p>{erssDetails?.erssStatus || "-"}</p>
                        </div>
                        <div className="sub-container-two">
                          <h6>Notify To:</h6>
                          <p>{sosAlertDetails?.receiverDetail || "-"}</p>
                        </div>
                      </div>
                      <div className="viewActivity-btn-div">
                        <button
                          onClick={() => setIsActivityOpen(!isActivityOpen)}
                          className={isActivityOpen ? "btn-is-active" : ""}
                        >
                          View Activity
                        </button>

                        <button
                          onClick={() => setShowStopage((prev) => !prev)}
                          className={showStopage ? "btn-is-active" : ""}
                        >
                          View Stopages
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="urlTracking-map-parent-div">
              <button
                className="live-url-track-gps-btn"
                onClick={handleRecenterMap}
              >
                <Image
                  src={mapReCenterBtn}
                  alt="gps-icon"
                  height={50}
                  width={50}
                />
              </button>
              <MapContainer
                center={position}
                zoom={zoomlevel}
                minZoom={parseInt(process.env.REACT_APP_MAP_MIN_ZOOM_LEVEL)}
                style={{ height: "100%", width: "100%" }}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                <MyMap setMap={setMap} />

                {routePath.length > 1 && (
                  <Polyline
                    positions={routePath}
                    pathOptions={{ color: "blue", weight: 4 }}
                  />
                )}

                {startPoint && (
                  <Marker position={startPoint} icon={OSMIcon_2}>
                    <Popup>Ticket Started</Popup>
                  </Marker>
                )}

                {livePath.length > 1 && (
                  <Polyline
                    positions={livePath}
                    pathOptions={{ color: "blue", weight: 4 }}
                  />
                )}

                {position && (
                  <LeafletTrackingMarker
                    icon={OSMIcon}
                    position={position}
                    previousPosition={prevPos}
                    duration={refreshTime * 1000}
                    // duration={25000}
                    title="Live Tracking"
                  />
                )}

                {showStopage &&
                  stopages.map((value, index) => (
                    <Marker
                      key={index}
                      position={[value.lat, value.lng]}
                      icon={OSMIcon_1}
                    >
                      <Popup>
                        <CCard>
                          <CCardBody className="px-0 mx-0 pb-0">
                            <CTable className="infoWindowTable mb-0">
                              <CTableBody>
                                <CTableRow>
                                  <CTableDataCell>
                                    <strong>Device Time</strong>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <strong> : </strong>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    {value.deviceTime}
                                  </CTableDataCell>
                                </CTableRow>
                                <CTableRow>
                                  <CTableDataCell>
                                    <strong>Duration</strong>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <strong> : </strong>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    {value.duration}
                                  </CTableDataCell>
                                </CTableRow>
                                <CTableRow>
                                  <CTableDataCell>
                                    <strong>Latitude</strong>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <strong> : </strong>
                                  </CTableDataCell>
                                  <CTableDataCell>{value.lat}</CTableDataCell>
                                </CTableRow>
                                <CTableRow>
                                  <CTableDataCell>
                                    <strong>Longitude</strong>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <strong> : </strong>
                                  </CTableDataCell>
                                  <CTableDataCell>{value.lng}</CTableDataCell>
                                </CTableRow>
                                <CTableRow>
                                  <CTableDataCell>
                                    <strong>Address</strong>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <strong> : </strong>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <strong>
                                      {addressIndex === index ? (
                                        <span>{address}</span>
                                      ) : (
                                        <span
                                          className="cursor"
                                          onKeyDown={(e) => e.preventDefault()}
                                          tabIndex={0}
                                          role="button"
                                          onClick={() =>
                                            GetStopageAddress(
                                              value.lat,
                                              value.lng,
                                              index,
                                            )
                                          }
                                          style={{ color: "rgb(3, 121, 202)" }}
                                        >
                                          Get Address
                                        </span>
                                      )}
                                    </strong>
                                  </CTableDataCell>
                                </CTableRow>
                                <CTableDataCell
                                  className="text-center stopage-share-btn"
                                  colSpan={4}
                                  style={{ borderBottom: "none" }}
                                >
                                  <CButton
                                    type="button"
                                    className="btn-sm badge badge-light-info mr-10 mt-2 mb-2"
                                    onClick={(e) =>
                                      handleShareBtn(
                                        e,
                                        value,
                                        "stopageLocation",
                                      )
                                    }
                                  >
                                    <i className="fa fa-share"></i>
                                    Share
                                  </CButton>
                                </CTableDataCell>
                              </CTableBody>
                            </CTable>
                          </CCardBody>
                        </CCard>
                      </Popup>
                    </Marker>
                  ))}
              </MapContainer>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UrlTracking;
